// CommentMentionToast.tsx
import ToasterWrapper from '@/react/components/ToasterWrapper'
import UserAvatar from '../UserAvatar';
import { generateThreadUrl, timeAgo } from './utils';
const { toast } = ToasterWrapper;

const Title = ({ type }) => {
	switch (type) {
		case 'mention':
			return <p className='text-xxs'><span className='font-semibold'>
				Mentioned
			</span> you in a comment</p>;
		case 'reply':
			return <p className='text-xxs'><span className='font-semibold'>
				Replied
			</span> to a comment</p>;
		case 'thread-created':
			return <p className='text-xxs'><span className='font-semibold'>
				Created
			</span> a thread</p>;
		case 'comment-created':
			return <p className='text-xxs'><span className='font-semibold'>
				Commented
			</span> on a thread</p>;
		default:
			return <p className='text-xxs'><span className='font-semibold'>
				Interacted
			</span> with a namespace</p>;
	}
};

export const showCommentNotificationToast = (data) => {
	const url = generateThreadUrl(data.thread);

	toast((t) =>
		// 4 types, mention, reply, thread-created, comment-created
		<div className='flex gap-2 items-start bg-white text-black'>
			<div className='mt-1 mr-1'>
				<UserAvatar name={data.author.name} src={data.author.avatar} size={36} />
			</div>
			<div className='flex flex-col gap-1 flex-1 whitespace-nowrap'>
				<div className='flex items-center gap-1'>
					<p className='font-bold text-primary'>
						{data.author.name}
					</p>
					<div className='text-[10px] flex items-center text-grey-text'><span className='inline-block w-1 h-1 bg-grey rounded-full mt-0.5 mr-1'></span>{timeAgo(data.comment.created_at)}</div>
				</div>
				<Title type={data.type} />
				<p className='text-xxs truncate text-grey-text'>{data.thread.title}</p>
			</div>

			{/* vertical rule */}

			<div className='h-full self-stretch w-[1px] bg-grey ml-4'>
			</div>

			<a className='text-primary ml-2 self-center' href={url} target='_blank' rel='noreferrer'>
				View
			</a>
		</div>
		, {
			duration: 8000,
			Icon: null,
		});
};